import React,{Fragment} from 'react';
import {connect} from 'react-redux'
import FormWorkContainer from './FormWorkContainer'
import {checkAuthAction} from "../../actions";
import {Layout, Card} from 'antd';
const {Header} = Layout;

class DefaultTemplateContainer extends React.Component {

    componentWillMount() {
        this.props.checkAuthAction(true)
    }

    render() {
        return (
            <FormWorkContainer
                fromWorkMain={this.htmlBody()}
            />

        )
    }

    htmlBody(){
        return(
            <Fragment>
                {this.props.title ?
                    <Header style={{ background: '#fff', padding: 0 }}>
                    <h1 className=''>
                        {this.props.title}
                        </h1>
                        <span className="col-auto align-self-center">
                        {this.props.menuButton}
                    </span>
                    </Header> : ''
                }
                <Card bordered={false} style={{minHeight: '100vh'}}>
                    {this.props.htmlBody}
                </Card>
            </Fragment>
        )
    }


}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToPorps = (dispatch) => ({
    checkAuthAction: (transfer) => (
        dispatch(checkAuthAction(dispatch,transfer))
    )
})

export default connect(mapStateToProps, mapDispatchToPorps)(DefaultTemplateContainer)


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/DefaultTemplateContainer/DefaultTemplateContainer.jsx